<template>
  <div  :style='{width: panelWidth}' >
      <el-table ref='risktable' :data='tableData' class='riskTable' :height="panelHeight" style='width: 100%' fit
          :cell-class-name = "() => 'lu-click'"
          :row-class-name="tableRowClassName"
          @sort-change='sortChange'
       >
        <el-table-column prop='instrumentName' ref='col1' sortable='custom' :dataKeys="['instrumentName']" sortFieldFormat="String" />
        <el-table-column align='center' :label='$t("Mio")' prop='totalMio' ref='col2' sortable='custom' :dataKeys="['totalMio']" sortFieldFormat="Number">
          <template slot-scope="data">
            <div style='text-align: right' :class='cellClass(data.row.totalMio)'>{{ data.row.totalMio | formatAmount(1) }}</div>
          </template>
        </el-table-column>
        <el-table-column align='center' :label='$t("PnL")' prop='totalPnL' ref='col3' sortable='custom' :dataKeys="['totalPnL']" sortFieldFormat="Number">
          <template slot-scope="data">
            <div style='text-align: right' :class='cellClass(data.row.totalPnL)'>{{ data.row.totalPnL | formatAmount(0) }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column align='center' :label='$t("VWAP")' prop='vwap' ref='col4' sortable='custom' :dataKeys="['vwap']" sortFieldFormat="Number">
          <template slot-scope="data">
            <div style='text-align: right' :class='cellClass(data.row.vwap)'>{{ data.row.vwap | formatRate(6) }}</div>
          </template>
        </el-table-column> -->
        <el-table-column align='center' :label='$t("EOD")' prop='rollOver' ref='col4' sortable='custom' :dataKeys="['rollOver']" sortFieldFormat="Number">
          <template slot-scope="data">
            <div style='text-align: right' :class='cellClass(data.row.rollOver)'>{{ data.row.rollOver | formatRate(5) }}</div>
          </template>
        </el-table-column>
        <el-table-column align='center' :label='$t("Current")' prop='best' ref='col5' sortable='custom' :dataKeys="['best']" sortFieldFormat="Number">
          <template slot-scope="data">
            <div style='text-align: right' :class='cellClass(data.row.best)'>{{ data.row.best | formatRate(5) }}</div>
          </template>
        </el-table-column>
      </el-table>
  </div>
</template>

<script>
import utils from '@/utils/formatNumber'
import { timestamp } from '@/utils'
import monitoringMixin from './mixins'
import { mapState } from 'vuex'

export default {
  name: 'Risk',
  props: [ 'data', 'panel' ],
  mixins: [ monitoringMixin ],
  filters: {
    formatAmount (value, bookPnLMode) {
      if (!value) {
        return utils.formatAmount(0, 2, 3, bookPnLMode)
      }
      return utils.formatAmount(value, 2, 3, bookPnLMode)
    },
    formatRate: function (value, prec, decsep = '.', thsep = ' ', emptyIfZero = true) {
      value = value || 0
      let idx = ('' + value).indexOf('.')
      if (idx !== -1) prec = value.length - idx - 1
      return utils.formatNumber(value, prec, decsep, thsep, emptyIfZero)
    }
  },
  data: function () {
    return {
      tableData: [],
      currentFilter: { }
    }
  },
  watch: {
    data: {
      handler (value) {
        this.updateData(value)
      },
      immediate: true
    }
  },
  computed: {
    ...mapState({ panelConfig: state => state.settingsMonitor.settingParams.panelConfig })
  },
  methods: {
    sortChange: function(data) {
      const { column, order } = data

      let currentCol = this.getColumn(column.id)

      let dataKeys = []
      let sortFieldFormat = ""
      if (currentCol && currentCol.hasOwnProperty('$attrs')) {
        dataKeys = currentCol.$attrs.dataKeys
        sortFieldFormat = currentCol.$attrs.sortFieldFormat
      }

      this.currentFilter = { dataKeys, sortFieldFormat, order }
      this.dataSort()
    },
    getColumn: function(columnId) {
      return this.getColumns().find(item => item.columnId === columnId)
    },
    getColumns: function() {
      let columns = []
      for (let ref of ["col1", "col2", "col3", "col4", "col5"]) {
        if (this.$refs[ref]!==null && this.$refs[ref]!==undefined) {
          if (Array.isArray(this.$refs[ref])) {
            columns = columns.concat(this.$refs[ref])
          } else {
            columns.push(this.$refs[ref])
          }
        }
      }
      return columns
    },
    dataSort: function() {
      let { dataKeys, sortFieldFormat, order } = this.currentFilter
      if (!(Boolean(dataKeys) && Boolean(order))) {
        // default
        dataKeys = ['totalMio']
        sortFieldFormat = 'Number'
        order = 'descending'
        this.currentFilter = { dataKeys, sortFieldFormat, order }
      }
      this.tableData.sort(this.sortBy(dataKeys,sortFieldFormat,order))
    },
    sortBy: function(dataKeys,sortFieldFormat,order) {
      return function(a,b) {
        let value = 0

        const getPropValue = (data,dataKeys,sortFieldFormat) => {
          let currentData = data
          for (let key of dataKeys) {
            if (currentData!==null && currentData!==undefined && currentData.hasOwnProperty(key)) {
              currentData = currentData[key]
            }
          }
          if (typeof currentData === "object") {
            if (sortFieldFormat === 'String') {
              currentData = ''
            } else if (sortFieldFormat === 'Number') {
              currentData = 0
            } else {
              currentData = 0
            }
          }

          //format
          if (sortFieldFormat === 'String') {
            value = currentData.toUpperCase() 
          } else if (sortFieldFormat === 'Number') {
            if (!currentData) {
              currentData = 0
            }
            value = Math.abs(parseFloat(currentData))
          }
          return value
        }

        let valueA = getPropValue(a,dataKeys,sortFieldFormat)
        let valueB = getPropValue(b,dataKeys,sortFieldFormat)

        // //ref
        if (a.instrumentName==='Instrument') {
          return -1
        }
        if (b.instrumentName==='Instrument') {
          return 1
        }

        if (valueA>valueB) {
          // return 1
          return order==='ascending' ? 1 : -1
        }
        else if (valueA<valueB) {
          // return  -1
          return order==='ascending' ? -1 : 1
        }

        return 0
      }
    },
    updateData(value) {
      let data = this.parseData(value)
      this.tableData = data.tableData
      this.dataSort()
      this.updateLayout()
    },
    updateLayout() {
      if (this.$refs.risktable && this.$refs.risktable.doLayout) {
          this.$refs.risktable.doLayout()
      }
    },
    getExcelSheetName() {
      let tmp = this.panelConfig.find(item => item.id === this.panel.id)
      let exportExcelFilePrefix = tmp ? tmp.exportExcelFilePrefix : ""

      return exportExcelFilePrefix
    },
    parseData (value) {
      let tableData = []
      if (value && value.length) {
        value.forEach(item => {
          let row = {
            instrumentName: item.instrumentName,
            label: item.label,
            totalMio: '',
            totalPnL: '',
            // vwap: '',
            best: item.best,
            rollOver: item.rollOver
          }
          if (item && item.roleList && item.roleList.length) {
            item.roleList.forEach(role => {
              if (role.title === 'TOTAL') {
                if (role.hasOwnProperty('exposure')) {
                  row.totalMio = role['exposure']
                } else {
                  row.totalMio= "0.00"
                }

                if (role.hasOwnProperty('profitAndLoss')) {
                  row.totalPnL = role['profitAndLoss']
                } else {
                  row.totalPnL= "0.00"
                }

                // row.vwap = role.vwap1
              }
            })
          }
          tableData.push(row)
        })
      }
      return {
        tableData: tableData
      }
    },
    cellClass (value) {
      return value < 0 ? 'negative' : 'positive'
    },
    handleDownload (dataList, sheetOnly) {
      return import('@/vendor/Export2Excel').then(excel => {
        let sheetList = []

        let data = this.parseData(dataList)

        let headers = [
          [ '' ]
        ]

        // Total
        headers[0].push(this.$t('Total Mio'))
        headers[0].push(this.$t('Total PnL'))
        // headers[0].push(this.$t('VWAP'))
        headers[0].push(this.$t('EOD'))
        headers[0].push(this.$t('Current'))

        let tableData = []
        data.tableData.forEach(row => {
          let thisRow = []
          thisRow.push(row.instrumentName)
          thisRow.push(row.totalMio)
          thisRow.push(row.totalPnL)
          // thisRow.push(row.vwap)
          thisRow.push(row.rollOver)
          thisRow.push(row.best)

          tableData.push(thisRow)
        })

        sheetList.push({
          multiHeader: headers,
          data: tableData,
          merges: [],
          sheetName: this.getExcelSheetName()
        })

        if (sheetOnly) {
          // return sheetList
          return {
            isMultiTab: true,
            tabList: sheetList
          }
        } else {
          let filename = this.panel.exportExcelFilePrefix + '_' +  timestamp()

          excel.export_json_to_excel_lusis_multisheet({
            filename: filename,
            autoWidth: true,
            bookType: 'xlsx',
            sheets: sheetList
          })
        }
      })
    }
  }
}
</script>

<style lang='scss'>
</style>